import { RouterView } from 'vue-router'

import { ROUTE_NAMES, ROUTE_PATHS } from '@/routes/route-helpers'
import AfterLoginGateway from '@web-app/login-app/views/after-login-gateway'
import WebAppLogin from '@web-app/login-app/views/web-app-login'
import WebAppLogout from '@web-app/login-app/views/web-app-logout'
import WebAppSignUp from '@web-app/login-app/views/web-app-sign-up'

const {
  WEB_APP_ACCOUNT_LAYOUT,
  WEB_APP_SIGN_UP,
  WEB_APP_LOGIN,
  WEB_APP_LOGOUT,
  WEB_APP_AFTER_LOGIN_GATEWAY,
  WEB_APP_SWITCH_ORGANIZATION
} = ROUTE_NAMES

export const LOGIN_APP_ROUTES = [
  {
    path: '/',
    name: 'Root',
    component: RouterView,
    children: [
      {
        path: ROUTE_PATHS.WEB_APP_ACCOUNT_LAYOUT,
        name: WEB_APP_ACCOUNT_LAYOUT,
        component: RouterView,
        redirect: { name: WEB_APP_LOGIN },
        children: [
          {
            path: ROUTE_PATHS.WEB_APP_SIGN_UP,
            name: WEB_APP_SIGN_UP,
            component: WebAppSignUp,
            meta: {
              shouldRedirectToLogin: false
            }
          },
          {
            path: ROUTE_PATHS.WEB_APP_LOGIN,
            name: WEB_APP_LOGIN,
            component: WebAppLogin,
            meta: {
              shouldRedirectToLogin: false
            }
          },
          {
            path: ROUTE_PATHS.WEB_APP_LOGOUT,
            name: WEB_APP_LOGOUT,
            component: WebAppLogout,
            meta: {
              shouldRedirectToGateway: false
            }
          },
          {
            path: ROUTE_PATHS.WEB_APP_AFTER_LOGIN_GATEWAY,
            name: WEB_APP_AFTER_LOGIN_GATEWAY,
            component: AfterLoginGateway,
            meta: {
              shouldRedirectToGateway: false
            }
          },
          {
            path: `${ROUTE_PATHS.WEB_APP_SWITCH_ORGANIZATION}/:organizationId`,
            name: WEB_APP_SWITCH_ORGANIZATION,
            component: { render: () => null }
          }
        ]
      }
    ]
  }
]
